module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Quản lý mã giảm giá"
    }
  }, [_c('router-link', {
    staticClass: "ui mini blue button",
    attrs: {
      "to": {
        name: 'create-promotion'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Thêm\n      mới")])], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('gs-table', {
    ref: _vm.promotionTable,
    attrs: {
      "table-name": _vm.promotionTable,
      "data-source": "promotions",
      "data-params": _vm.filters,
      "data-sorted": _vm.sorted,
      "data-sorts": _vm.sorts
    },
    on: {
      "remove-filter": _vm.removeFilter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": "",
            "row-class-name": _vm.tableRowClassName
          }
        }, [_vm._v("\n          >\n          "), _c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.promotionTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) +
                ((_vm.dataPaginations[_vm.promotionTable].current_page - 1) *
                  _vm.dataPaginations[_vm.promotionTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Mã giảm giá"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_c('span', {
                staticClass: "shipment-code-display"
              }, [_vm._v(_vm._s(scope.row.code))])]), _vm._v(" "), _c('p', [_vm._v("Ngày tạo: " + _vm._s(scope.row.created_at))]), _vm._v(" "), (_vm.promotionHelpers.sources) ? _c('p', [_vm._v("Nguồn: "), _c('span', {
                staticClass: "ui label blue"
              }, [_vm._v(_vm._s(_vm.promotionHelpers.sources[scope.row.source]))])]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Phạm vi áp dụng"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("HVC: " + _vm._s(scope.row.carrier_name))]), _vm._v(" "), _c('p', [_vm._v("Gửi từ: " + _vm._s(scope.row.city_from_name))]), _vm._v(" "), _c('p', [_vm._v("Gửi đến: " + _vm._s(scope.row.city_to_name))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thời gian áp dụng"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Từ ngày: " + _vm._s(scope.row.start_date))]), _vm._v(" "), _c('p', [_vm._v("Đến ngày: " + _vm._s(scope.row.end_date))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Giảm giá"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_c('span', {
                staticClass: "text-red"
              }, [_vm._v(_vm._s(_vm._f("number")(scope.row.discount)) + " " + _vm._s(scope.row.currency))])]), _vm._v(" "), _c('p', [_vm._v("Giảm tối đa: "), _c('span', {
                staticClass: "text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.max_discount)))])]), _vm._v(" "), _c('p', [_vm._v("Số lượng: "), _c('span', {
                staticClass: "text-red"
              }, [_vm._v(_vm._s(_vm._f("number")(scope.row.quantity)))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Trạng thái"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_c('span', {
                staticClass: "ui label",
                class: [{
                  'red': !scope.row.is_active
                }, {
                  'green': scope.row.is_active
                }]
              }, [_vm._v(_vm._s(scope.row.status))])]), _vm._v(" "), _c('p', [_vm._v("Kiểu áp dụng: " + _vm._s(scope.row.type))]), _vm._v(" "), _c('p', [_vm._v("Số lượng áp dụng cho từng user: " + _vm._s(_vm._f("number")(scope.row.quantity_per_user)))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Số đơn"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v(_vm._s(_vm._f("number")(scope.row.total_shipment)))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "95"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [(!scope.row.deleted_at) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Sửa"
                }
              }, [_c('router-link', {
                staticClass: "text-orange padding-all display-inline-block cursor-pointer",
                attrs: {
                  "to": {
                    name: 'edit-promotion',
                    params: {
                      id: scope.row.id
                    }
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-pencil-square-o",
                attrs: {
                  "aria-hidden": "true"
                }
              })])], 1) : _vm._e(), _vm._v(" "), (!scope.row.deleted_at) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xóa"
                }
              }, [_c('a', {
                staticClass: "text-red padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.deletePromotion(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-trash"
              })])]) : _vm._e(), _vm._v(" "), (scope.row.deleted_at) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Khôi phục"
                }
              }, [_c('a', {
                staticClass: "text-blue padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    return _vm.restore(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-refresh",
                attrs: {
                  "aria-hidden": "true"
                }
              })])]) : _vm._e()], 1)]
            }
          }], null, true)
        })], 1)]
      }
    }])
  }, [_c('section', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-66a75536"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/promotion/Promotion.vue
// module id = 714
// module chunks = 1